import Vue from 'vue'
import moment from 'moment'

import { humanFileSize } from '@/utilities/file-helper'

Vue.filter('formatDate', function (value) {
  if (!value) return
  return moment(String(value)).format('MM/DD/YYYY')
})

Vue.filter('formatDateTime', function (value) {
  if (!value) return
  return moment(String(value)).format('MM/DD/YYYY hh:mm:ss')
})

Vue.filter('formatFileSize', function (value) {
  if (!value) return
  return humanFileSize(value)
})

Vue.filter('formatDecimal', function (value, digits) {
  if (isNaN(value)) return
  return parseFloat(value).toFixed(digits)
})

Vue.filter('notSupplied', function (value) {
  if (!value) return '(empty)'
  return value
})
